import React, { useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Search from '../Searchbar/Search';
import { useSelector } from "react-redux";
import LoginBtn from './reg-button/LoginBtn';
import { FiMenu } from "react-icons/fi"; 
import SignupBtn from './reg-button/SignupBtn';
import Logout from './reg-button/Logout';
import LogoutButton from './reg-button/LogoutNew';

const Navbar = () => {
    const user = JSON.parse(localStorage.getItem('users'));
    const cartItems = useSelector((state) => state.cartreducer.carts);
    const navigate = useNavigate();

    const logout = () => {
        localStorage.clear('users');
        navigate("/login");
    };

    const [menu, setMenu] = useState(false);

    return (
        <nav className="sticky top-0 z-20">
            {/* Top Navbar */}
            <div className="bg-[#F6F8F7] py-4 md:px-12 px-4 flex items-center justify-between">
                <div>
                    <Link to={'/'}>
                        <img className="md:h-24 h-16 logo" src="./images/durapot-logo.jpg" alt="Logo"/>
                    </Link>
                </div>
                {/* <div className=" mx-2 ">
                    <Search />
                </div> */}
                <div className='flex items-center'>
                    {/* Cart */}
                    <Link to={'/cart'} className="relative flex items-center gap-2 transition duration-300">
                        <div className="relative md:mr-6 ">
                            <i className="fa-solid fa-cart-shopping text-3xl"></i>
                            {cartItems.length > 0 && (
                                <span className="absolute -top-2 -right-3 bg-red-500 text-white text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full shadow-md border-2 border-white">
                                    {cartItems.length}
                                </span>
                            )}
                        </div>
                    </Link>

                    {/* User Role Section */}
                    {user ? (
                        <Link 
                            to={user?.role === "user" 
                                ? '/userDashboard' 
                                : user?.role === "admin" 
                                ? '/adminDashboard' 
                                : '/sellerDashboard'}
                            className="hidden md:flex items-center text-lg font-poppins space-x-2 px-4 font-medium text-black rounded-md transition-all duration-300"
                        >
                            <i className="fa-solid fa-user"></i>
                            <span>{user?.name}</span>
                        </Link>
                    ) : (
                     ""
                    )}
                    
                </div>
            </div>
            
        
{/* Desktop Navigation */}
<div className="hidden md:flex justify-between items-center bg-green-700 py-3 text-white  px-12">
    {/* Centered Nav Items */}
    <ul className="flex text-lg space-x-6 font-medium mx-auto">
        <li>
            <Link 
                to={'/'} 
                className="font-poppins relative before:content-[''] before:absolute before:bottom-0 before:left-0 before:w-0 before:h-[2px] before:bg-black before:transition-all before:duration-300 hover:before:w-full"
            >
                Home
            </Link>
        </li>
        <li>
            <Link 
                to={'/allproduct'} 
                className="font-poppins relative before:content-[''] before:absolute before:bottom-0 before:left-0 before:w-0 before:h-[2px] before:bg-black before:transition-all before:duration-300 hover:before:w-full"
            >
                Products
            </Link>
        </li>

      
    

     
       <li>
            <Link 
                to={'/contactUs'} 
                className="font-poppins relative before:content-[''] before:absolute before:bottom-0 before:left-0 before:w-0 before:h-[2px] before:bg-black before:transition-all before:duration-300 hover:before:w-full"
            >
                Contact Us
            </Link>
        </li>
    </ul>

    {/* User Section (Right Corner) */}
    <div className="absolute right-12 flex items-center space-x-4">
        {!user ? (
            <>
                <Link
                    to={'/signup'}
                >
                   
                   <SignupBtn/>
                </Link>
                <Link
                    to={'/login'}
                >
                  <LoginBtn />
                </Link>
            </>
        ) : (
          
            <div onClick={logout}>
           
            <LogoutButton/>
            </div>
           
        )}
    </div>
</div>



            {/* Mobile Menu Button */}
            <div className="md:hidden flex justify-end bg-green-500  text-black px-5 py-3">
                {/* <button onClick={() => setMenu(true)} className="text-3xl text-white">&#9776;</button> */}
                {/* <FiMenu className="h-8 w-8 text-white cursor-pointer" onClick={() => setMenu(true)} /> */}
                <img src="/hamberger-icon.png" alt="hamberger-icon" onClick={() => setMenu(true)}    className="h-8 cursor-pointer invert"/>
            </div>
            
            {/* Mobile Sidebar */}
            <div onClick={() => setMenu(false)} className={`fixed inset-0  bg-black bg-opacity-50 z-30 transition-transform duration-300 ${menu ? 'translate-x-0' : '-translate-x-full'}`}>
                <div  className="bg-white w-3/4 h-full p-5 shadow-lg relative">
                    <button onClick={() => setMenu(false)} className="absolute top-4 right-4 text-5xl">&times;</button>
                    <ul className="flex flex-col space-y-6 mt-10 text-lg">
                        <li>
                            <Link to={'/'} onClick={() => setMenu(false)}>Home</Link>
                        </li>
                        <li>
                            <Link to={'/allproduct'} onClick={() => setMenu(false)}>Products</Link>
                        </li>
                       

                        {!user ? (
                            <>
                                <li>
                                    <Link to={'/signup'} onClick={() => setMenu(false)}><SignupBtn/></Link>
                                </li>
                                <li>
                                    <Link to={'/login'} onClick={() => setMenu(false)}><LoginBtn /></Link>
                                </li>
                            </>
                        ) : (
                            <>
                                <li>
                                    <Link 
                                        to={user?.role === "user" 
                                            ? '/userDashboard' 
                                            : user?.role === "admin" 
                                            ? '/adminDashboard' 
                                            : '/sellerDashboard'} 
                                        onClick={() => setMenu(false)}
                                    >
                                        {user?.name}
                                    </Link>
                                </li>

                                <li onClick={logout}>
                                  
                                    <Logout onClick={() => setMenu(false)}  />
                                </li>
                            
                            </>
                        )}
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
